import { initializeApp, FirebaseApp } from "firebase/app";
import { getFirestore, Firestore } from "firebase/firestore";
import { getDatabase, Database } from "firebase/database";

const firebaseConfig = {
  apiKey: 'AIzaSyCFL1C9mGhalil9yXdtyqIZ1Zb45n33fIY',
  authDomain: 'plazza-rider.firebaseapp.com',
  databaseURL: 'https://plazza-rider-default-rtdb.asia-southeast1.firebasedatabase.app',
  projectId: 'plazza-rider',
  storageBucket: 'plazza-rider.firebasestorage.app',
  messagingSenderId: '133170151992',
  appId: '1:133170151992:web:f2314a1bec96dbe891dccd',
};

const app: FirebaseApp = initializeApp(firebaseConfig);
const db: Firestore = getFirestore(app);
const database: Database = getDatabase(app);

export { db, database };
